export default __webpack_public_path__ + "static/media/quick-action.1f965dab.png";